import { CustomResource, KnownResources } from './models';


/**
 * Curried function, returns a predicate that checks whether or not the given resource is of the given type AKA "name"
 */
export const isSpecificResource = (
  resourceName: string,
) => (
  resource: CustomResource,
): boolean => resource.nameText.toLowerCase() === resourceName.toLowerCase();


export const isDevResources     = isSpecificResource(KnownResources.DevResources);
export const isTutorialResource = isSpecificResource(KnownResources.Tutorial);
